import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CloseIcon(props) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1 1L9 9",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9 1L1 9",
                strokeWidth: "1.5"
            })
        ]
    });
}
